import type { RegionCode } from '#shared/lib/region'
import type { Ref } from 'vue'

import { DEFAULT_REGION, regionByHost } from '#shared/lib/region'

// Регион текущего запроса. На сервере берётся из event.context (server/middleware/region),
// в браузер приходит через payload useState — при гидратации регион не меняется.
export const useRegion = (): Readonly<Ref<RegionCode>> => {
  return useState<RegionCode>('region', () => {
    if (import.meta.server) {
      const contextRegion = useRequestEvent()?.context.region
      if (contextRegion) {
        return contextRegion
      }

      const headers = useRequestHeaders(['x-forwarded-host', 'host'])
      return regionByHost(headers['x-forwarded-host'] ?? headers.host) ?? DEFAULT_REGION
    }

    return regionByHost(window.location.host) ?? DEFAULT_REGION
  })
}
